// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"99fdca28","453":"49bd3eb8","459":"86d9150f","655":"afd6537a","697":"96be34d9","761":"8b573fda","971":"104a3823","990":"a491826a"}[chunkId] + ".chunk.js";
};